export const SMART_GUIDE_SNAP_THRESHOLD = 20;

export const SMART_GUIDE_COLOR = '#0EA5E9';
export const SMART_GUIDE_LINE_WIDTH = 4;
